// extracted by mini-css-extract-plugin
module.exports = {"panel":"Ingredient_panel__q7J_t","outOfStock":"Ingredient_outOfStock__13hwc","selected":"Ingredient_selected__19pBW","image":"Ingredient_image__1sQbk"};